const config = {
  maxFileUpload: 3,
  maxFileSize: 6000001, // 6MB
  maxFloatRecipients: 30,
  maxFloatCandidates: 100,
  maxFloatSlugLength: 45,

  maxSubmissionRecipients: 30,
  maxSubmissionCandidates: 100,
  maxSubmissionSlugLength: 45,

  drawerWidth: 240,

  candidateAttributes: ["Languages", "Tools", "Skills", "Education"],

  floatDefaults: {
    initialSkills: 6,
    initialRoles: 3,
    initialProjects: 2,
    initialEducation: 3,
  },

  validContactPlaceholders: ["first_name", "last_name", "company"],

  csvboxCandidateSheetLicenceKey:
    process.env.NEXT_PUBLIC_CSVBOX_CANDIDATE_SHEET_KEY,
  csvboxContactSheetLicenceKey:
    process.env.NEXT_PUBLIC_CSVBOX_CONTACT_SHEET_KEY,

  pusherAppKey: process.env.NEXT_PUBLIC_PUSHER_APP_KEY,
  apiBaseUrl: process.env.NEXT_PUBLIC_LARAVEL_API_URL,

  // Upper bound for requests on the public Float/Submission share pages so a
  // stalled/blocked request fails fast instead of hanging the page indefinitely.
  // Applied per-request (not globally) so long-running authenticated calls — AI
  // chat, CV import, text enhancement — are unaffected. Override via
  // NEXT_PUBLIC_PUBLIC_PAGE_API_TIMEOUT (ms).
  publicPageApiTimeout:
    Number(process.env.NEXT_PUBLIC_PUBLIC_PAGE_API_TIMEOUT) || 30000,

  privacyPolicyUrl: "https://floats.ai/privacy.html",
  termsOfServiceUrl: "https://floats.ai/terms.html",

  confettiColours: ["#13319a", "#e50b71", "#4c91f7", "#F9E8FF"],

  defaultSkillLogo: "/img/floats/skill-icon.png",

  cvImport: {
    promptName: process.env.CV_IMPORT_PROMPT_NAME || "import_master",
    aiModel: process.env.CV_IMPORT_AI_MODEL || "gpt-4.1-mini",
    aiModelFast:
      process.env.CV_IMPORT_AI_MODEL_FAST ||
      process.env.CV_IMPORT_AI_MODEL ||
      "gpt-4.1-mini",
    rawTextModel: process.env.CV_IMPORT_RAW_TEXT_MODEL || "gpt-5.4-mini",
  },

  chat: {
    aiModel: process.env.CHAT_AI_MODEL || "gpt-4.1-mini",
  },

  jobBrief: {
    promptName: process.env.JOB_BRIEF_PROMPT_NAME || "import_job_brief",
    aiModel: process.env.JOB_BRIEF_AI_MODEL || "gpt-4.1-mini",
  },
};

export default config;
